var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import { Country } from 'country-state-city';
import { Typeahead } from 'react-bootstrap-typeahead';
import ReactCountryFlag from 'react-country-flag';

import './CountrySelect.scss';
var CountrySelect = function CountrySelect(props) {
  return React.createElement(Typeahead, _extends({
    className: 'country-selector',
    options: Country.getAllCountries(),
    labelKey: 'name',
    id: 'country-selector'
  }, props, {

    renderMenuItemChildren: function renderMenuItemChildren(option, props, index) {
      /* Render custom contents here. */
      return React.createElement(
        'div',
        null,
        React.createElement(ReactCountryFlag, {
          countryCode: option.isoCode,
          svg: true,
          className: 'mr-2 flag'
        }),
        option.name
      );
    }
  }));
};

export default CountrySelect;